import styled from 'styled-components';
import { grey25, grey75, navy, coral, pink25 } from '@zocdoc/branding/colors';

import {
    NON_INPUT_X_AFFORDANCE_DESKTOP,
    NON_INPUT_X_AFFORDANCE_MOBILE,
} from '../../../picker-constants';

import { breakpoint } from '../../../grid';
import { FontFamily } from '../../../typography';

export const LoadingContainer = styled.div`
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SectionList = styled.div`
    ${breakpoint.small} {
        max-height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }
`;

export const SectionFooter = styled.div`
     margin: 0 0 12px;
`;

export const SectionSeparator = styled.div`
    margin: 16px ${NON_INPUT_X_AFFORDANCE_MOBILE}px 8px;
    border-top: 1px solid ${grey25};

    ${breakpoint.small} {
        margin-left: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
        margin-right: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
    }
`;

export const SectionHeader = styled.div`
    color: ${grey75};
    font: 15px/24px ${FontFamily.SharpSansSemibold};
    padding-top: ${p => p.searchPlans ? '8px' : ''};
    padding: 4px ${NON_INPUT_X_AFFORDANCE_MOBILE}px;
    text-size-adjust: none;
    width: 100%;

    ${breakpoint.small} {
        padding-left: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
        padding-right: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
    }
`;

export const SectionItem = styled.div`
    box-sizing: inherit;
    color: ${navy};
    font: 13px/24px ${FontFamily.SharpSansSemibold};
    list-style: none;
    padding: 4px ${NON_INPUT_X_AFFORDANCE_MOBILE}px;
    position: relative;
    text-size-adjust: none;

    em {
        color: ${coral};
    }

    cursor: ${p => p.selected ? 'pointer' : ''};
    background-color: ${p => p.selected ? pink25 : ''};

    &:active {
        cursor: pointer;
        background-color: ${pink25};
        -webkit-tap-highlight-color: ${pink25};
    }

    ${breakpoint.small} {
        padding-left: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;
        padding-right: ${NON_INPUT_X_AFFORDANCE_DESKTOP}px;

        &:hover {
            cursor: pointer;
            background-color: ${pink25};
        }
    }
`;
